<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="apartmentName"
    ></project-flow-navigation-toolbar>

    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
        <v-tab href="#media"> Media </v-tab>
        <!-- <v-tab href="#pois">
          Points of interest
        </v-tab> -->
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%" value="details">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row class="mt-1">
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  dense
                  v-model="apartment.name"
                  label="Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  dense
                  :items="$store.state.ApartmentTypeStore.apartmentTypes"
                  v-model="apartment.apartmentTypeId"
                  @change="handleApartmentTypeChange()"
                  label="Apartment Type"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  dense
                  :items="
                    $store.state.ApartmentOrientationStore.apartmentOrientations
                  "
                  v-model="apartment.apartmentOrientationId"
                  @change="handleApartmentOrientationChange()"
                  label="Apartment Orientation"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  dense
                  :items="getStatuses"
                  v-model="apartment.statusId"
                  label="Status"
                  item-text="name"
                  item-value="id"
                  @change="setStatusValue(apartment.statusId)"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  outlined
                  dense
                  v-model="apartment.floor"
                  label="Floor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  outlined
                  dense
                  v-model="apartment.area"
                  label="Area"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  outlined
                  dense
                  v-model="apartment.rooms"
                  label="Rooms"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="(item, key) in apartment.properties"
                :key="key"
                cols="2"
                sm="2"
                md="2"
                :class="key.toLowerCase()"
              >
                <universal-field-editor
                  v-if="key.toLowerCase() !== 'status'"
                  v-model="apartment.properties[key]"
                  :field-key="key"
                  :field-type="getFieldEditorType(key)"
                  :field-select-items="getFieldEditorSelectItems(key)"
                ></universal-field-editor>
                <!--                  <component-->
                <!--                    :is="getFieldEditorComponent(key)"-->
                <!--                    :field-value="{ value: apartment.properties[key] }"-->
                <!--                    :field-key="key"-->
                <!--                  ></component>-->
                <!--                  <v-text-field-->
                <!--                    outlined-->
                <!--                    dense-->
                <!--                    v-model="apartment.properties[key]"-->
                <!--                    :label="key"-->
                <!--                  ></v-text-field>-->
              </v-col>
            </v-row>
            <v-row v-if="isAllowedApartmentPropertiesActions">
              <v-dialog v-model="newFieldDialog" max-width="500px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="blue darken-1"
                    class="ma-2"
                    v-on="on"
                    @click="editProperties"
                    >Add new field</v-btn
                  >
                  <v-btn color="blue darken-1" class="ma-2" @click="generatePoi"
                    >Generate Default Poi</v-btn
                  >
                </template>
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="newFieldName"
                            label="Field name"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="newFieldDefaultValue"
                            label="Default value"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeNewFieldDialog"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="saveNewField"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="editJSONDialog" max-width="500px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="blue darken-1"
                    class="ma-2"
                    v-on="on"
                    @click="editProperties"
                    >Edit properties JSON</v-btn
                  >
                </template>
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-jsoneditor
                            v-model="propertiesTemp"
                            :plus="true"
                            height="300px"
                            :options="{
                              mode: 'code',
                              theme: 'ace/theme/tomorrow_night_bright',
                              mainMenuBar: false
                            }"
                          ></v-jsoneditor>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeEditJSONDialog"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveEditJSONDialog"
                      >Save</v-btn
                    >
                    <v-btn color="red darken-1" @click="deleteApartment"
                      >Delete</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <!-- <v-row>
              <v-card outlined>
                <v-card-title>Apartment custom properties</v-card-title>
                <v-form-base
                  :model="customPropertiesModel"
                  :schema="customPropertiesSchema"
                  @input="handleInput"
                />
              </v-card>
            </v-row> -->
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteApartment">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item value="media">
        <media :media="this.$store.state.MediaStore.media"></media>
      </v-tab-item>
      <!-- <v-tab-item value="pois">
        <v-list-item>
          <v-list-item-content>
            <poi-list
              :poi-list="this.$store.state.PoiStore.pois"
              parentType="apartment"
              :parent="this.$store.state.ApartmentStore.selectedApartment"
            ></poi-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item> -->
    </v-tabs-items>
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import PoiList from '../../components/RecordLists/PoiList'
import VJsoneditor from 'v-jsoneditor/src/index'
import UsersService from '../../services/UsersService'
import { UserRolesMixin } from '../../mixins/UserRolesMixin'
import UniversalFieldEditor from '@/components/FieldEditors/UniversalFieldEditor'
import 'brace'
import 'brace/theme/tomorrow_night_bright'
import VFormBase from 'vuetify-form-base'
import { mapState } from 'vuex'
import ApartmentService from '../../services/ApartmentService'

export default {
  name: 'ApartmentExplore',
  props: {},
  components: {
    UniversalFieldEditor,
    ProjectFlowNavigationToolbar,
    Media,
    VJsoneditor
  },
  data: function() {
    return {
      pois: [],
      apartment: {},
      apartmentId: null,
      title: '',
      tab: null,
      changeDetected: false,
      newFieldName: '',
      newFieldDefaultValue: null,
      newFieldDialog: false,
      editJSONDialog: false,
      propertiesTemp: null,
      isAllowedApartmentPropertiesActions: true,
      customPropertiesModel: {},
      customPropertiesSchema: {},
      selectedApartmentType: {},
      selectedApartmentOrientation: {}
    }
  },
  mixins: [UserRolesMixin],

  computed: {
    ...mapState('ApartmentStore', ['selectedApartment']),
    apartmentName: function() {
      return this.selectedApartment ? this.selectedApartment.name : ''
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    },
    apartmentProperties: function() {
      return this.apartment.properties
    },
    getStatuses() {
      let statuses = []
      for (const property in Enums.ApartmentStatus) {
        statuses.push({
          id: Enums.ApartmentStatus[property],
          name: this.$t(`apartmentStatuses.${property}`)
        })
      }
      return statuses
    }
    // getFieldEditorComponent: {
    //   get: function(fieldKey) {
    //     return PlainTextField
    //   }
    // }
  },
  methods: {
    getFieldEditorType: function(fieldKey) {
      let retFieldType = Enums.FieldEditorType.plainText
      switch (fieldKey.toLowerCase()) {
        case 'unitstatus': {
          retFieldType = Enums.FieldEditorType.selectBoxSingleValue
        }
      }
      return retFieldType
    },
    getFieldEditorSelectItems: function(fieldKey) {
      let retValue = []
      switch (fieldKey.toLowerCase()) {
        case 'unitstatus': {
          retValue = [
            { id: 'available', label: 'available' },
            { id: 'pending-reservation', label: 'pending-reservation' },
            { id: 'reserved', label: 'reserved' },
            { id: 'booked', label: 'booked' },
            { id: 'sold', label: 'sold' },
            { id: 'unavailable', label: 'unavailable' }
          ]
        }
      }
      return retValue
    },
    async generatePoi() {
      const apartment = this.$store.state.ApartmentStore.selectedApartment
      const defaultPoi = await ApartmentService.createDefaultPoi(apartment)
      if (defaultPoi) {
        this.$store.dispatch(
          'NotificationStore/add',
          { type: 'info', message: `Default Poi Successfully created` },
          { root: true }
        )
      } else {
        this.$store.dispatch(
          'NotificationStore/error',
          {
            type: 'error',
            message: `Something went wrong with creating default poi`
          },
          { root: true }
        )
      }
    },
    getData: async function() {
      this.isAllowedApartmentPropertiesActions = await this.isAllowedOnResource(
        'apartment-properties-edit-buttons',
        'show'
      )
      if (this.apartmentId) {
        await this.$store.dispatch('MediaStore/resetStore')

        await this.$store.dispatch(
          'ApartmentStore/setSelectedApartment',
          this.apartmentId,
          { root: true }
        )
        this.apartment = JSON.parse(JSON.stringify(this.selectedApartment))

        if (!this.apartment.properties.apartmentTourUrl) {
          this.apartment.properties.apartmentTourUrl = ''
        }

        if (!this.apartment.properties.price) {
          this.apartment.properties.price = '0'
        }

        this.setStatusValue(this.apartment.statusId)
        this.selectedApartmentType = this.getApartmentType(
          this.apartment.apartmentTypeId
        )
        this.selectedApartmentOrientation = this.getApartmentOrientation(
          this.apartment.apartmentOrientationId
        )

        if (
          this.selectedApartmentType &&
          this.selectedApartmentType.properties &&
          Object.prototype.hasOwnProperty.call(
            this.selectedApartmentType.properties,
            'apartmentFieldsSchema'
          )
        ) {
          this.customPropertiesSchema = this.selectedApartmentType.properties[
            'apartmentFieldsSchema'
          ]
        }

        if (
          this.apartment.properties &&
          Object.prototype.hasOwnProperty.call(
            this.apartment.properties,
            'apartmentTypeCustomProperties'
          )
        ) {
          this.customPropertiesModel = this.apartment.properties[
            'apartmentTypeCustomProperties'
          ]
        }

        await this.$store.dispatch('PoiStore/setPoiContext', 'apartment')
        await this.$store.dispatch('PoiStore/fetchPois')

        // find default poi
        let defaultPoi = this.$store.state.PoiStore.pois.find(el => {
          return el.poiTypeId === Enums.PoiType.poi_type_apartment
        })
        if (defaultPoi) {
          await this.$store.dispatch('PoiStore/setSelectedPoi', defaultPoi.id)
          await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
          await this.$store.dispatch('MediaStore/fetchMediaTypes')
          await this.$store.dispatch('MediaStore/fetchMedia')
        }
      }
    },
    save: async function() {
      this.apartment.statusValue = this.$store.state.ApartmentStore.status
      await this.$store
        .dispatch('ApartmentStore/updateApartment', this.apartment)
        .then(res => {
          this.$store.dispatch('ApartmentStore/fetchApartments')
        })
      // Updateovanje apartmenta se sada izvrsava u updateApartment akciji:
      // await this.$store.dispatch(
      //   'ApartmentStore/setSelectedApartment',
      //   this.$route.params.apartmentId
      // )
      this.apartment = JSON.parse(JSON.stringify(this.selectedApartment))
      this.changeDetected = false
    },
    discard() {
      this.apartment = JSON.parse(JSON.stringify(this.selectedApartment))
      this.changeDetected = false
    },
    saveNewField: function() {
      let self = this
      if (!this.propertiesTemp) this.propertiesTemps = {}
      if (this.propertiesTemp.hasOwnProperty(this.newFieldName)) {
        this.$store.dispatch(
          'NotificationStore/add',
          {
            type: 'error',
            message: `The field with the given name already exists.`
          },
          { root: true }
        )
      } else {
        this.propertiesTemp[this.newFieldName] = this.newFieldDefaultValue
        this.apartment.properties = JSON.parse(
          JSON.stringify(this.propertiesTemp)
        )
      }
      this.closeNewFieldDialog()
    },
    deleteApartment: async function() {
      this.$confirm({
        title: 'Delete Apartment',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'ApartmentStore/deleteApartment',
              this.$route.params.apartmentId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Apartment has child records attached, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    },
    handleApartmentTypeChange: function() {
      this.selectedApartmentType = this.getApartmentType(
        this.apartment.apartmentTypeId
      )

      this.apartment.apartmentTypeId = this.selectedApartmentType.id
      this.apartment.area = this.selectedApartmentType.area
      this.apartment.rooms = this.selectedApartmentType.rooms
    },
    handleApartmentOrientationChange: function() {
      this.selectedApartmentOrientation = this.getApartmentOrientation(
        this.apartment.apartmentOrientationId
      )

      this.apartment.apartmentOrientationId = this.selectedApartmentOrientation.id
    },
    getApartmentType: function(apartmentTypeId) {
      return this.$store.state.ApartmentTypeStore.apartmentTypes.find(item => {
        return item.id === apartmentTypeId
      })
    },
    getApartmentOrientation: function(apartmentOrientationId) {
      return this.$store.state.ApartmentOrientationStore.apartmentOrientations.find(
        item => {
          return item.id === apartmentOrientationId
        }
      )
    },
    closeNewFieldDialog: function() {
      this.newFieldName = ''
      this.newFieldDefaultValue = null
      this.newFieldDialog = false
    },
    saveEditJSONDialog: function() {
      this.apartment.properties = this.propertiesTemp
      this.closeEditJSONDialog()
    },
    closeEditJSONDialog: function() {
      this.editJSONDialog = false
    },
    editProperties: function() {
      this.propertiesTemp = this.apartment.properties
    },
    setStatusValue: function(id) {
      this.$store.dispatch('ApartmentStore/setApartmentValue', id)
    },
    handleInput: function(e) {
      this.apartment.properties = Object.assign({}, this.apartment.properties, {
        apartmentTypeCustomProperties: this.customPropertiesModel
      })
    }
  },
  created() {
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 2
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'P.O.I ') {
        this.tab = 'pois'
      }
    }
  },
  mounted: function() {},
  watch: {
    apartment: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.apartment) !==
            JSON.stringify(this.selectedApartment)
        }
      }
    },
    apartmentProperties: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function() {
        this.changeDetected =
          JSON.stringify(this.apartment.properties) !==
          JSON.stringify(this.selectedApartment.properties)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.apartmentId = to.params.apartmentId
      await vm.getData()
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.apartmentId = to.params.apartmentId
    await this.getData()
    next()
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('ApartmentStore/resetStore')
    if (to.name === 'Explore Poi') {
      localStorage.exploreApartmentActiveTab = this.tab
    } else {
      localStorage.exploreApartmentActiveTab = 'details'
    }
    next()
  }
}
</script>

<style scoped>
.status {
  display: none;
}
</style>
